import moment from 'moment';
import 'moment-timezone';

export default function (value, format = 'DD-MM-YYYY', utc = false, timezone = '', wordFormat = false) {
  if (!value) return '';

  let m;
  if (utc) {
    m = timezone ? moment.utc(value).tz(timezone) : moment.utc(value);
  } else {
    m = timezone ? moment(value).tz(timezone) : moment(value);
  }

  if (wordFormat) {
    let now;

    if (utc) {
      now = timezone ? moment.utc().tz(timezone) : moment.utc();
    } else {
      now = timezone ? moment().tz(timezone) : moment();
    }

    now.startOf('day');

    const valueDate = m.clone().startOf('day'); // Clone to avoid mutating the original m

    if (valueDate.isSame(now, 'day')) {
      return `Today at ${m.format('hh:mm a')}`;
    }

    const yesterday = now.clone().subtract(1, 'days');

    if (valueDate.isSame(yesterday, 'day')) {
      return `Yesterday at ${m.format('hh:mm a')}`;
    }

    // If wordFormat is true but not today or yesterday, use the specified format
    return m.format(format);
  }

  return m.format(format);
}
